import styled from 'styled-components';
import { Layout } from 'antd';
import * as color from 'modules/common/theme/color';
import { device } from 'modules/common/theme/mediaqueries';

const contentWidth = '1200px';

const Wrap = styled(Layout.Header)`
  background-color: ${color.Black};
  height: 70px;
  justify-content: center;
  display: flex;
`;

const InnerWrap = styled.div`
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${contentWidth};
  margin: 0 auto;

  @media ${device.tabletS} {
    width: 100%;
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    flex-direction: row;
    position: relative;
  }
`;

const HeaderText = styled.p`
  font-size: 24px;
  line-height: 32px;
  font-weight: bold;
  color: ${color.White};
  margin: 0px;

  @media ${device.tabletS} {
    display: none;
  }
`;

const Logo = styled.img`
  width: 205px;

  @media ${device.tabletS} {
    margin: 0 auto;
  }
`;

export default {
  Wrap,
  HeaderText,
  Logo,
  InnerWrap,
};
